import clsx from 'clsx';
import Image from 'components/commercetools-ui/atoms/image';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { desktop } from 'helpers/utils/screensizes';
import { BrandPromiseProps, ServiceHighlightsCardTypes } from '../types';
import CardWrapper from './card-wrapper';

export default function ServiceHighlightsCard({
  className,
  index = 0,
  ...props
}: ServiceHighlightsCardTypes & BrandPromiseProps) {
  const [isDesktopSize] = useMediaQuery(desktop);
  const subTitleClassName = clsx('md:w-4/5 leading-normal');
  const {
    iconLight,
    title,
    subTitle,
    deliveryOptionsBackgroundImage,
    subTitleTextSizeLg,
    subTitleTextColor,
    titleTextSizeLg,
    titleTextColor,
    titleTextSizeSm,
    subTitleTextSizeSm,
  } = props;
  const titleClassName = clsx('md:w-4/5 leading-normal');
  return (
    <CardWrapper
      className={className}
      index={isDesktopSize ? index : index + 1}
      backgroundStyles={deliveryOptionsBackgroundImage}
      {...props}
    >
      <Image
        media={iconLight?.media}
        style={{ objectFit: 'cover' }}
        height={isDesktopSize ? 80 : 72}
        width={isDesktopSize ? 80 : 72}
        data-ffid={`img-service-icon-${index}`}
      />
      <p
        style={{
          color: titleTextColor,
          fontSize: `${isDesktopSize ? titleTextSizeLg : titleTextSizeSm}px`,
        }}
        className={titleClassName}
        data-testid={`lbl-service-title-${index}`}
        data-ffid={`lbl-service-title-${index}`}
      >
        {title}
      </p>
      <p
        style={{
          color: subTitleTextColor,
          fontSize: `${isDesktopSize ? subTitleTextSizeLg : subTitleTextSizeSm}px`,
        }}
        className={subTitleClassName}
        data-testid={`lbl-service-subTitle-${index}`}
        data-ffid={`lbl-service-subTitle-${index}`}
      >
        {subTitle}
      </p>
    </CardWrapper>
  );
}
